import React from 'react';
import '../TeleCalling.css';
import { Box, Typography, Tab } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { handleValidateCodevalue } from '../../../Utility/constant';
import TcSectionLoader from './TcSectionLoader';
import CustomerCard from './CustomerCard';
import { useCallContext } from '../useCallContext';

const CustomerContextDetails = ({ customers = [], internationalise, isLoading, minimize }) => {
    const { selectedCustomerTab, setSelectedCustomerTab } = useCallContext();

    if (isLoading) {
        return <TcSectionLoader className="tc-customer-loader" sx={{ mb: 1 }} />;
    }

    if (!customers || customers.length === 0) {
        return (
            <Box className="tc-section-box">
                <Typography
                    variant="subtitle2"
                    className="tc-section-header"
                >
                    {handleValidateCodevalue(internationalise, 'TC_CUSTOMER_DETAILS')}
                </Typography>
                <Typography variant="body2" color="text.secondary" className="tc-pl-05">
                    {handleValidateCodevalue(internationalise, 'COMMON_NO_DATA_FOUND')}
                </Typography>
            </Box>
        );
    }

    return (
        <Box className="tc-section-box">
            <Typography
                variant="subtitle2"
                className="tc-section-header"
            >
                {handleValidateCodevalue(internationalise, 'TC_CUSTOMER_DETAILS')}
            </Typography>

            <TabContext value={selectedCustomerTab}>
                <Box className="tc-tabs-header-row">
                    <TabList
                        onChange={(_, newVal) => setSelectedCustomerTab(newVal)}
                        variant="scrollable"
                        allowScrollButtonsMobile
                    >
                        {customers.map((cust, idx) => (
                            <Tab
                                key={idx}
                                value={String(idx)}
                                label={
                                    cust.firstName
                                        ? `${cust.firstName} ${cust.lastName || ''}`.trim()
                                        : `Customer #${cust.id}`
                                }
                                className="tc-actionable-tab"
                                sx={{ minHeight: 40 }}
                            />
                        ))}
                    </TabList>
                </Box>

                {customers.map((cust, idx) => (
                    <TabPanel key={idx} value={String(idx)} className="tc-tab-panel">
                        <CustomerCard customer={cust} internationalise={internationalise} minimize={minimize} />
                    </TabPanel>
                ))}
            </TabContext>
        </Box>
    );
};

export default CustomerContextDetails;
